import { DatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { esES as pickersEsES } from "@mui/x-date-pickers/locales";
import moment from "moment";
import Button from "../../../components/button";
import styles from "./styles.module.css";
import useTolls from "../../../hooks/useTolls";
import TollGridSection from "./grid-section";

const Tolls = () => {
  const {
    tableSections,
    modifiedCells,
    selectedYear,
    setSelectedYear,
    processRowUpdate,
    handleSaveChanges,
    isLoading,
  } = useTolls();

  return (
    <div className={styles.container}>
      <LocalizationProvider
        dateAdapter={AdapterMoment}
        adapterLocale="es"
        localeText={
          pickersEsES.components.MuiLocalizationProvider.defaultProps.localeText
        }
      >
        <div className={styles.header}>
          <h3 className={styles.title}>Peajes</h3>
          <div className={styles.headerActions}>
            <DatePicker
              views={["year"]}
              openTo="year"
              value={moment(selectedYear, "YYYY")}
              maxDate={moment()}
              onChange={(newValue) =>
                setSelectedYear(
                  newValue ? newValue.format("YYYY") : moment().format("YYYY")
                )
              }
              slotProps={{
                textField: {
                  size: "small",
                  className: styles.datePicker,
                },
              }}
            />
            <Button
              variant="outline"
              onClick={handleSaveChanges}
              disabled={modifiedCells.size === 0 || isLoading}
            >
              Guardar Cambios
            </Button>
          </div>
        </div>
      </LocalizationProvider>

      <div className={styles.tablesWrapper}>
        {tableSections.map((section) => (
          <TollGridSection
            key={section.key}
            section={section}
            isLoading={isLoading}
            modifiedCells={modifiedCells}
            processRowUpdate={processRowUpdate}
          />
        ))}
      </div>
    </div>
  );
};

export default Tolls;
